import JSON5 from 'json5';

import { BotCompilerError } from './validate-csv';

export type ErrorResponse = {
  errors: string | string[];
  messages: string[];
};

const parseLooseJson = (input: string): BotCompilerError[] => {
  try {
    const fixedInput = input
      .replace(/\bNone\b/g, 'null')
      .replace(/(?<!: ")\b"(.*?)"\b/g, '\\"$1\\"');
    return JSON5.parse(fixedInput);
  } catch (finalError) {
    console.error('Failed to parse loose JSON', finalError);
    return [
      // {
      //   row_num: null,
      //   node_num: null,
      //   row_index: null,
      //   node_index: null,
      //   err_msgs: [
      //     {
      //       field_name: null,
      //       field_entry: null,
      //       error_description: 'Failed to parse loose JSON',
      //     },
      //   ],
      // },
    ];
  }
};

export const extractCompilerErrors = (
  response: ErrorResponse
): BotCompilerError[] | null => {
  const compilerErrorPrefix = 'Compiler error:';
  const invalidVersionMessage =
    'Version is not valid.  Please update before deploying.';

  const compilerLine = response.messages.find((msg) =>
    msg.startsWith(compilerErrorPrefix)
  );

  const invalidVersionLine = response.errors === invalidVersionMessage;

  let result: BotCompilerError[] = [];

  if (compilerLine) {
    const jsonPart = compilerLine.slice(compilerErrorPrefix.length).trim();

    // console.log(
    //   '=====================jsonPart before parsing=====================',
    //   jsonPart
    // );

    result = parseLooseJson(jsonPart);
  }

  if (invalidVersionLine) {
    const notAllowedErrors = [
      'Solution version has not been properly compiled.',
    ];

    const errors = response.messages
      .map((msg) => ({
        row_num: null,
        node_num: null,
        cell_num: null,
        node_index: null,
        cell_index: null,
        err_msgs: [
          {
            error_description: msg,
          },
        ],
      }))
      .filter(
        ({ err_msgs }) =>
          !notAllowedErrors.includes(err_msgs[0].error_description)
      )
      .filter(
        ({ err_msgs }) =>
          !err_msgs[0].error_description.startsWith(compilerErrorPrefix)
      );

    result = [...result, ...errors];
  }

  // console.log('=====================result=====================', result);

  return result;
};
